import React from 'react';
import classNames from 'classnames';
import cls from './TableFooterReconciliation.module.css';
import { useTableFooterReconciliation } from './useTableFooterReconciliation';

interface TableFooterReconciliationProps {
    classes?: string;
    contractPrice: number;
    orderSum: number;
    customerPayment: number;
    customerBePaid: number;
    currencyCode: string;
}

export const TableFooterReconciliation = ({
    classes,
    contractPrice,
    orderSum,
    customerBePaid,
    customerPayment,
    currencyCode,
}: TableFooterReconciliationProps) => {
    const {} = useTableFooterReconciliation();
    return (
        <div className={classNames(cls.TableFooterReconciliation, [classes])}>
            <div className={classNames(cls.TableColumn, cls.TableColumnTitle)}>
                {i18next.t('TableFooterReconciliation.return.result')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{contractPrice}</div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{orderSum}</div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>
                {customerBePaid}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>
                {customerPayment}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableColumnValue)}>{currencyCode}</div>
        </div>
    );
};
